import React from "react";
// import HowItWorks
import HowItWorks from "./HowItWorks";
// import VideoAreaTwo
import VideoAreaTwo from "./VideoAreaTwo";
// import AboutServices
import AboutServices from "../About/Services";
// import AboutServices
import InquiryForm from "./InquiryForm";

const BecomeExpertArea = () => {
  return (
    <>
      {/* <!-- How It Work --> */}
      {/* <HowItWorks/> */}
      {/* <AboutServices padding={true}/> */}

      <InquiryForm />
      {/* <!-- Video Area --> */}
      <VideoAreaTwo />

      {/* <!-- AboutServices--> */}

      {/* <!-- Vendor Form Area --> */}
    </>
  );
};

export default BecomeExpertArea;
